export default __webpack_public_path__ + "static/training-a11y-4e1c6655a26e752b435e85e805b8cd26.png";